import * as React from 'react';
import { Element } from 'react-scroll';

export default function QuoteFormTitle() {
  return (
    <Element name="index" className="col-12 mt20">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-8 col-md-7 col-lg-6 padding-auto-custom">
          <h1 className="text-center mx-auto mb5 px-24">
            Cotiza tu Seguro de Salud Complementario
          </h1>
          <h2 className="text-center text-primary mb30 px-16">
            Un reembolso adicional para tus gastos médicos
          </h2>
        </div>
      </div>
    </Element>
  );
}
